import { ViewController } from 'elc-service';
import { action, observable, computed } from 'mobx';
import { PriceFormatter } from 'elc-formatters';
import {
    IProductInstallmentsPrice,
    IProductInstallmentsConfig
} from '../views/product-installments-price/ProductInstallmentsPrice';
import { ComponentTypes } from '../constants/ComponentTypes';

export interface IInstallmentsControllerConfig {
    installments: IProductInstallmentsConfig;
}

export class ProductInstallmentsPriceViewController extends ViewController {
    @observable private isInstallmentsModalOpen: boolean = false;
    private priceFormatter: PriceFormatter;
    private componentType: ComponentTypes;
    private config: IInstallmentsControllerConfig;

    constructor(priceFormatter: PriceFormatter) {
        super();
        this.priceFormatter = priceFormatter;
    }

    @action
    public initialize = (props: IProductInstallmentsPrice) => {
        const { componentType, config } = props;
        this.componentType = componentType;
        this.config = config as IInstallmentsControllerConfig;
    };

    @computed
    public get componentConfig() {
        const { overrides, ...installmentsConfig } = this.config
            .installments as IProductInstallmentsConfig;

        const configOverrides = overrides && overrides[this.componentType];

        return { ...installmentsConfig, ...configOverrides };
    }

    @computed
    get data() {
        return {
            isInstallmentsModalOpen: this.isInstallmentsModalOpen,
            componentConfig: this.componentConfig
        };
    }

    public getFormattedPrice = (price: number) => {
        return this.priceFormatter.formatPriceWithCurrency(price);
    };

    @action
    public openModal = () => {
        this.isInstallmentsModalOpen = true;
    };

    @action
    public closeModal = () => {
        this.isInstallmentsModalOpen = false;
    };

    public setIntervalPrice = (price: number, intervals: number) => {
        const absoluteIntervals = Math.abs(intervals);
        if (absoluteIntervals > 0) {
            return price / absoluteIntervals;
        }

        return price;
    };
}
